var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLetterA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "15px",
    width: "15px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 489.8 489.8",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M256.4,113c-0.1-0.2-0.2-0.3-0.2-0.5c-0.2-0.4-0.4-0.8-0.6-1.2c-0.2-0.3-0.4-0.7-0.6-1s-0.5-0.6-0.7-0.9 c-0.3-0.3-0.5-0.6-0.8-0.9s-0.5-0.5-0.8-0.7c-0.3-0.3-0.7-0.5-1-0.8c-0.3-0.2-0.6-0.4-0.9-0.5c-0.4-0.2-0.8-0.4-1.3-0.6 c-0.2-0.1-0.3-0.2-0.5-0.2c-0.2-0.1-0.3-0.1-0.5-0.1c-0.5-0.1-0.9-0.3-1.4-0.3c-0.3-0.1-0.7-0.1-1-0.2c-0.4,0-0.8-0.1-1.3-0.1 c-0.4,0-0.8,0-1.2,0.1c-0.4,0-0.7,0.1-1.1,0.2c-0.5,0.1-0.9,0.2-1.3,0.3c-0.2,0.1-0.3,0.1-0.5,0.1c-0.2,0.1-0.3,0.2-0.5,0.2 c-0.4,0.2-0.8,0.4-1.2,0.6c-0.3,0.2-0.6,0.4-0.9,0.5c-0.4,0.2-0.7,0.5-1,0.8c-0.3,0.2-0.6,0.5-0.8,0.7c-0.3,0.3-0.6,0.6-0.8,0.9 c-0.3,0.3-0.5,0.6-0.7,0.9s-0.4,0.6-0.6,1c-0.2,0.4-0.4,0.8-0.6,1.2c-0.1,0.2-0.2,0.3-0.2,0.5l-91.5,255.6 c-2.3,6.4,1,13.4,7.4,15.7c1.4,0.5,2.8,0.7,4.1,0.7c5,0,9.7-3.1,11.5-8.1l26.2-73.3h106.3c0.3,0,0.6-0.1,1-0.1l26.2,73.4 c1.8,5,6.5,8.1,11.5,8.1c1.4,0,2.8-0.2,4.1-0.7c6.4-2.3,9.7-9.3,7.4-15.7L256.4,113z M200,279l44.9-125.5L289.8,279H200z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterA);
export default __webpack_public_path__ + "static/media/letter-a.676877d9149170460c55c3e37a249fca.svg";
export { ForwardRef as ReactComponent };